import { useCallback } from 'react';
import { useFiltersContext } from '@framework/ui/Organisms/Filters/FiltersContext';
import { useFilterActions } from '@/creditflowresearch/application/Research/useFilterActions';
import { IResearchFilterState } from '@/creditflowresearch/domain/vo/research/IFilterContextData';

export const useFilterInitialization = () => {
  const { filtersUpdate } = useFiltersContext();
  const { payloadChange, initFilters } = useFilterActions();

  return useCallback(async (
    filtersPayload: IResearchFilterState,
    filtersState: IResearchFilterState,
    isHashFiltersPayload: boolean,
  ): Promise<void> => {
    if (Object.keys(filtersPayload).length === 0) return;

    payloadChange(filtersPayload);

    if (isHashFiltersPayload) {
      await initFilters(filtersPayload, undefined, isHashFiltersPayload, filtersUpdate);
    } else {
      await initFilters(filtersPayload, filtersState, false, filtersUpdate);
    }
  }, [payloadChange, initFilters, filtersUpdate]);
};
